import { render, staticRenderFns } from "./videolist.vue?vue&type=template&id=5f4156fc&scoped=true"
import script from "./videolist.vue?vue&type=script&lang=js"
export * from "./videolist.vue?vue&type=script&lang=js"
import style0 from "./videolist.vue?vue&type=style&index=0&id=5f4156fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4156fc",
  null
  
)

export default component.exports